export const FETCH_RESULT = 'FETCH_RESULT';
export const LIST_RESULT6 = 'leap6d';
export const LIST_RESULT5 = 'leap5d';
export const DRAW_RESULT5 = 'DRAW_RESULT5';
export const DRAW_RESULT6 = 'DRAW_RESULT6';
